import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=b602afa8"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports